/**
 * Tiny classname joiner (no clsx/tailwind-merge dependency).
 * Filters falsy values so conditional classes stay readable:
 *   cn('px-3', isActive && 'bg-primary', disabled && 'opacity-50')
 */
export function cn(
  ...parts: Array<string | false | null | undefined>
): string {
  return parts.filter(Boolean).join(' ');
}
